import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { environment } from 'environments/environment';
import { GuiasService } from '../services/guias/guias.service';
import { filterServifinTiposServicio } from '../shared/servifin-tipo-servicio.util';


//select Tipo Operacion NOTA DEBITO
@Component({
  selector: 'app-select-tipoOperacionND',
  template: `<mat-form-field [appearance]="modelSelect"><mat-label>Tipo de operación</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="tipoOperacionNDElement" [required] = "require">
               <div *ngIf="view">
                 <mat-option value=0>
                    All
                  </mat-option>
                </div>
                  <mat-option *ngFor="let tipoOperacionND of TipoOperacionND" [value]="tipoOperacionND.idGuia" >
                   {{tipoOperacionND.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})

export class SelectTipoOperacionNDComponent implements OnInit {

  @Output() tipoOperacionND : EventEmitter<string> = new EventEmitter();
  @Input() tipoOperacionNDElement : string;
  @Input() view : boolean;
  @Input() require : boolean;
  @Input() modelSelect : string;
  @Input() disable : boolean;
  TipoOperacionND:any;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.TipoOperacionND.subscribe(
      response => {
        this.TipoOperacionND= response;   
      });
  }

  changeClient(value) {
    this.tipoOperacionND.emit(value);
}

}


//select Moneda
@Component({
  selector: 'app-select-moneda',
  template: `<mat-form-field [appearance]="modelSelect"><mat-label>Moneda</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="monedaElement" (filtroMoneda)="filtroMoneda" [disabled]="disable" [required] = "require">
               <div *ngIf="view">
                 <mat-option value=''>
                    All
                  </mat-option>
                </div>
                  <mat-option *ngFor="let moneda of TipoMoneda" [value]="moneda.idGuia" >
                   {{moneda.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})

export class SelectMonedaComponent implements OnInit {

  @Output() tipoMoneda : EventEmitter<string> = new EventEmitter();
  @Input() filtroMoneda:string;
  @Input() monedaElement : string;
  @Input() disable : boolean;
  @Input() modelSelect : string;
  @Input() view : boolean;
  @Input() require : boolean;
  TipoMoneda:any = [];

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.TipoMoneda.subscribe(
      response => {
        this.TipoMoneda= response;
        if (this.filtroMoneda && this.TipoMoneda ) {
          this.TipoMoneda =  this.TipoMoneda.filter(
            state => state.Codigo != this.filtroMoneda
          );
        }   
      });
  }

  changeClient(value) {
    this.tipoMoneda.emit(value);
}

}

//select Banco

@Component({
  selector: 'app-select-banco',
  template: `<mat-form-field><mat-label>Banco</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="bancoElement" [required] = "require">
               <div *ngIf=view>
                  <mat-option value=0>
                    All
                  </mat-option>
                </div>
                  <mat-option *ngFor="let banco of TipoBanco" [value]="banco.idGuia" >
                   {{banco.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})



export class SelectBancoComponent implements OnInit {


  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  @Output() banco : EventEmitter<string> = new EventEmitter();
  @Input() bancoElement:string;
  @Input() view : boolean;
  @Input() require : boolean;
  TipoBanco:any;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.TipoBanco.subscribe(
      response => {
        this.TipoBanco= response;   
      });
  }

  changeClient(value) {
    this.banco.emit(value);
}
}

//select TipoPago

@Component({
  selector: 'app-select-tipoPago',
  template: `<mat-form-field><mat-label>Tipo de pago</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)">
                <div *ngIf="view">
                  <mat-option value=''>
                    All
                  </mat-option>
                </div>    
                  <mat-option *ngFor="let tipoPago of TipoPago" [value]="tipoPago.idGuia" >
                   {{tipoPago.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})



export class SelectTipoPagoComponent implements OnInit {

  @Output() tipoPago : EventEmitter<string> = new EventEmitter();
  @Input() view : boolean;
  TipoPago:any;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.TipoPago.subscribe(
      response => {
        this.TipoPago= response;   
      });
  }

  changeClient(value) {
    
    this.tipoPago.emit(value);
}
}

//select TipoContacto

@Component({
  selector: 'app-select-tipoContacto',
  template: `<mat-form-field><mat-label>Tipo de contacto</mat-label>
              <mat-select  (selectionChange)="changeClient($event.value)" [(ngModel)]="tipoContactoElement">
                  <mat-option *ngFor="let tipoContacto of TipoContacto" [value]="tipoContacto.idGuia" >
                   {{tipoContacto.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})



export class SelectTipoContactoComponent implements OnInit {

  @Input() tipoContactoElement:string ;
  
  @Output() tipoContacto : EventEmitter<string> = new EventEmitter();
  TipoContacto:any;
  

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.TipoContacto.subscribe(
      response => {
        this.TipoContacto = response;   
      });
  }

  changeClient(value) {
    
    this.tipoContacto.emit(value);
}
}

//select TipoDocumento

@Component({
  selector: 'app-select-tipoDocumento',
  template: `<mat-form-field><mat-label>Tipo de documento</mat-label>
              <mat-select  (selectionChange)="changeClient($event.value)" [(ngModel)]="tipoDocumentoElement" [disabled]="disable" required>
                  <mat-option *ngFor="let tipoDocumento of TipoDocumento" [value]="tipoDocumento.idGuia" >
                   {{tipoDocumento.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})



export class SelectTipoDocumentoComponent implements OnInit {

  @Input() tipoDocumentoElement:string;
  @Input() disable:boolean ;
  @Output() tipoDocumento : EventEmitter<string> = new EventEmitter();
  TipoDocumento:any;
  enable:boolean;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.TipoDocumento.subscribe(
      response => {
         this.TipoDocumento = response;
      });
  }

  changeClient(value) {
    
    this.tipoDocumento.emit(value);
}
}

//select IgvExonerado

@Component({
  selector: 'app-select-igvExonerado',
  template: `<mat-form-field [appearance]="modelSelect"><mat-label>IGV</mat-label>
              <mat-select  (selectionChange)="changeClient($event.value)" [(ngModel)]="igvExoneradoElement" [disabled]="disable" required>
                  <mat-option *ngFor="let igvExonerado of IgvExonerado" [value]="igvExonerado.idGuia" >
                   {{igvExonerado.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})



export class SelectIgvExoneradoComponent implements OnInit {

  @Input() igvExoneradoElement:string;
  @Input() disable:boolean ;
  @Input() modelSelect : string;
  @Output() igvExonerado : EventEmitter<string> = new EventEmitter();
  IgvExonerado:any;
  enable:boolean;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.IgvExonerado.subscribe(
      response => {
         this.IgvExonerado = response;
      });
  }

  changeClient(value) {
    
    this.igvExonerado.emit(value);
}
}


//select RolContacto

@Component({
  selector: 'app-select-rolContacto',
  template: `<mat-form-field><mat-label>Rol del contacto</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" multiple [(ngModel)]="rolContactoElement">
                  <mat-option *ngFor="let rolContacto of RolContacto" [value]="rolContacto.idGuia" >
                    {{rolContacto.Descripcion}}
                  </mat-option>
              </mat-select>
             </mat-form-field>`         
})

// `<mat-form-field><mat-label>Rol del contacto</mat-label>
// <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="rolContactoElement">
//     <mat-option *ngFor="let rolContacto of RolContacto" [value]="rolContacto.idGuia" >
//      {{rolContacto.Descripcion}}
//     </mat-option>
// </mat-select>
// </mat-form-field>`


export class SelectRolContactoComponent implements OnInit {
  
  @Input() rolContactoElement:string;
  @Output() rolContacto : EventEmitter<string> = new EventEmitter();
  RolContacto:any;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.RolContacto.subscribe(
      response => {
        this.RolContacto = response;   
      });
  }

  changeClient(value) {
    
    this.rolContacto.emit(value);
}
}

//select Tipo cuenta

@Component({
  selector: 'app-select-tipoCuenta',
  template: `<mat-form-field><mat-label>Tipo de cuenta</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="tipoCuentaElement" [required] = "require">
                  <mat-option *ngFor="let tipoCuenta of TipoCuenta" [value]="tipoCuenta.idGuia" >
                   {{tipoCuenta.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})



export class SelectTipoCuentaComponent implements OnInit {

  @Output() tipoCuenta : EventEmitter<string> = new EventEmitter();
  @Input() tipoCuentaElement:string;
  @Input() require : boolean;
  TipoCuenta:any;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.TipoCuenta.subscribe(
      response => {
        this.TipoCuenta = response;   
      });
  }

  changeClient(value) {
    
    this.tipoCuenta.emit(value);
}
}

//select tipoComprobante

@Component({
  selector: 'app-select-tipoComprobante',
  template: `<mat-form-field><mat-label>Tipo de documento</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="tipoComprobanteElement" [required] = "require">
                 <div *ngIf="view">
                   <mat-option value=0>
                     All
                   </mat-option>  
                </div>  
                  <mat-option *ngFor="let tipoComprobante of TipoComprobante" [value]="tipoComprobante.idGuia" >
                   {{tipoComprobante.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})



export class SelectTipoComprobanteComponent implements OnInit {

  @Output() tipoComprobante : EventEmitter<string> = new EventEmitter();
  @Input() tipoComprobanteElement:string;
  @Input() require : boolean;
  @Input() view : boolean;
  TipoComprobante:any;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.TipoComprobante.subscribe(
      response => {
        this.TipoComprobante = response;   
      });
  }

  changeClient(value) {
    
    this.tipoComprobante.emit(value);
}
}

//select tipoComprobanteIF

@Component({
  selector: 'app-select-tipoComprobanteIF',
  template: `<mat-form-field><mat-label>Tipo de documento</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="tipoComprobanteIFElement" [required] = "require">
                 <div *ngIf="view">
                   <mat-option value=0>
                     All
                   </mat-option>  
                </div>  
                  <mat-option *ngFor="let tipoComprobanteIF of TipoComprobanteIF" [value]="tipoComprobanteIF.idGuia" >
                   {{tipoComprobanteIF.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})



export class SelectTipoComprobanteIFComponent implements OnInit {

  @Output() tipoComprobanteIF : EventEmitter<string> = new EventEmitter();
  @Input() tipoComprobanteIFElement:string;
  @Input() require : boolean;
  @Input() view : boolean;
  TipoComprobanteIF:any;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.TipoComprobanteIF.subscribe(
      response => {
        this.TipoComprobanteIF = response;   
      });
  }

  changeClient(value) {
    
    this.tipoComprobanteIF.emit(value);
}
}

//select comprobanteEmitido

@Component({
  selector: 'app-select-comprobanteEmitido',
  template: `<mat-form-field><mat-label>Comprobante emitido</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="comprobanteEmitidoElement" [required] = "require">
                  <mat-option *ngFor="let comprobanteEmitido of ComprobanteEmitido" [value]="comprobanteEmitido.idGuia" >
                   {{comprobanteEmitido.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})



export class SelectComprobanteEmitidoComponent implements OnInit {

  @Output() comprobanteEmitido : EventEmitter<string> = new EventEmitter();
  @Input() comprobanteEmitidoElement:string;
  @Input() require : boolean;
  ComprobanteEmitido:any;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.ComprobanteEmitido.subscribe(
      response => {
        this.ComprobanteEmitido = response;   
      });
  }

  changeClient(value) {
    
    this.comprobanteEmitido.emit(value);
}
}

//select comprobanteContabilizado

@Component({
  selector: 'app-select-comprobanteContabilizado',
  template: `<mat-form-field><mat-label>Comprobante contabilizado</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="comprobanteContabilizadoElement" [required] = "require">
                  <mat-option *ngFor="let comprobanteContabilizado of ComprobanteContabilizado" [value]="comprobanteContabilizado.idGuia" >
                   {{comprobanteContabilizado.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})



export class SelectComprobanteContabilizadoComponent implements OnInit {

  @Output() comprobanteContabilizado : EventEmitter<string> = new EventEmitter();
  @Input() comprobanteContabilizadoElement:string;
  @Input() require : boolean;
  ComprobanteContabilizado:any;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.ComprobanteContabilizado.subscribe(
      response => {
        this.ComprobanteContabilizado = response;   
      });
  }

  changeClient(value) {
    
    this.comprobanteContabilizado.emit(value);
}
}

//select condicion

@Component({
  selector: 'app-select-condicion',
  template: `<mat-form-field><mat-label>Categoría</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="condicionElement" [required] = "require">
                  <mat-option *ngFor="let condicion of Condicion" [value]="condicion.idGuia" >
                   {{condicion.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})



export class SelectCondicionComponent implements OnInit {

  @Output() condicion : EventEmitter<string> = new EventEmitter();
  @Input() condicionElement:string;
  @Input() require : boolean;
  Condicion:any;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.Condicion.subscribe(
      response => {
        this.Condicion = response;   
      });
  }

  changeClient(value) {
    
    this.condicion.emit(value);
}
}

//select tipoConformidad

@Component({
  selector: 'app-select-tipoConformidad',
  template: `<mat-form-field><mat-label>Tipo de conformidad</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="tipoConformidadElement" [required] = "require">
                  <mat-option *ngFor="let tipoConformidad of TipoConformidad" [value]="tipoConformidad.idGuia" >
                   {{tipoConformidad.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})



export class SelectTipoConformidadComponent implements OnInit {

  @Output() tipoConformidad : EventEmitter<string> = new EventEmitter();
  @Input() tipoConformidadElement:string;
  @Input() require : boolean;
  TipoConformidad:any;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.TipoConformidad.subscribe(
      response => {
        this.TipoConformidad = response;   
      });
  }

  changeClient(value) {
    
    this.tipoConformidad.emit(value);
}
}



//select tipoEmision

@Component({
  selector: 'app-select-tipoEmision',
  template: `<mat-form-field><mat-label>Tipo emisión</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="tipoEmisionElement" [required] = "require">
                  <div *ngIf="view">
                    <mat-option value=0>
                      All
                    </mat-option>  
                  </div>  
                  <mat-option *ngFor="let tipoEmision of TipoEmision" [value]="tipoEmision.idGuia" >
                   {{tipoEmision.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})



export class SelectTipoEmisionComponent implements OnInit {

  @Output() tipoEmision : EventEmitter<string> = new EventEmitter();
  @Input() tipoEmisionElement:string;
  @Input() require : boolean;
  @Input() view : boolean;
  TipoEmision:any;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.TipoEmision.subscribe(
      response => {
        this.TipoEmision = response;   
      });
  }

  changeClient(value) {
    
    this.tipoEmision.emit(value);
}
}
//select fondoGarantiaBase

@Component({
  selector: 'app-select-fondoGarantiaBase',
  template: `<mat-form-field><mat-label>Fondo garantía base</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="fondoGarantiaBaseElement" [required] = "require" [disabled] = "disable">
                  <mat-option *ngFor="let fondoGarantiaBase of FondoGarantiaBase" [value]="fondoGarantiaBase.idGuia" >
                   {{fondoGarantiaBase.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})



export class SelectFondoGarantiaBaseComponent implements OnInit {

  @Output() fondoGarantiaBase : EventEmitter<string> = new EventEmitter();
  @Input() fondoGarantiaBaseElement:string;
  @Input() require : boolean;
  @Input() disable : boolean;
  FondoGarantiaBase:any;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.RetencionBase.subscribe(
      response => {
        this.FondoGarantiaBase = response;   
      });
  }

  changeClient(value) {
    
    this.fondoGarantiaBase.emit(value);
}
}

//select detraccionBase

@Component({
  selector: 'app-select-detraccionBase',
  template: `<mat-form-field><mat-label>Detracción base</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="detraccionBaseElement" [required] = "require" [disabled] = "disable">
                  <mat-option *ngFor="let detraccionBase of DetraccionBase" [value]="detraccionBase.idGuia" >
                   {{detraccionBase.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})



export class SelectDetraccionBaseComponent implements OnInit {

  @Output() detraccionBase : EventEmitter<string> = new EventEmitter();
  @Input() detraccionBaseElement:string;
  @Input() require : boolean;
  @Input() disable : boolean;
  DetraccionBase:any;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.RetencionBase.subscribe(
      response => {
        this.DetraccionBase = response;   
      });
  }

  changeClient(value) {
    
    this.detraccionBase.emit(value);
}
}

//select retencionBase

@Component({
  selector: 'app-select-retencionBase',
  template: `<mat-form-field><mat-label>Retención base</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="retencionBaseElement" [required] = "require" [disabled] = "disable">
                  <mat-option *ngFor="let retencionBase of RetencionBase" [value]="retencionBase.idGuia" >
                   {{retencionBase.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})



export class SelectRetencionBaseComponent implements OnInit {

  @Output() retencionBase : EventEmitter<string> = new EventEmitter();
  @Input() retencionBaseElement:string;
  @Input() require : boolean;
  @Input() disable : boolean;
  RetencionBase:any;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.RetencionBase.subscribe(
      response => {
        this.RetencionBase = response;   
      });
  }

  changeClient(value) {
    
    this.retencionBase.emit(value);
}
}

//select retencionBase

@Component({
  selector: 'app-select-retencion',
  template: `<mat-form-field><mat-label>Retención Base</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="retencionElement" [required] = "require">
                  <mat-option *ngFor="let retencion of Retencion" [value]="retencion.idGuia" >
                   {{retencion.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})



export class SelectRetencionComponent implements OnInit {

  @Output() retencion : EventEmitter<string> = new EventEmitter();
  @Input() retencionElement:string;
  @Input() require : boolean;
  Retencion:any;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.Retencion.subscribe(
      response => {
        this.Retencion = response;   
      });
  }

  changeClient(value) {
    
    this.retencion.emit(value);
}
}


//select tipoXls

@Component({
  selector: 'app-select-tipoXls',
  template: `<mat-form-field><mat-label>Tipo de archivo</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="tipoXlsElement" [required] = "require">
                  <mat-option *ngFor="let tipoXls of TipoXls" [value]="tipoXls.idGuia" >
                   {{tipoXls.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})



export class SelectTipoXlsComponent implements OnInit {

  @Output() tipoXls : EventEmitter<string> = new EventEmitter();
  @Input() tipoXlsElement:string;
  @Input() require : boolean;
  TipoXls:any;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.TipoXls.subscribe(
      response => {
        this.TipoXls = response;   
      });
  }

  changeClient(value) {
    
    this.tipoXls.emit(value);
}
}

//select tipoPlanilla

@Component({
  selector: 'app-select-tipoPlanilla',
  template: `<mat-form-field><mat-label>Tipo de formulario</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="tipoPlanillaElement" [required] = "require">
                  <mat-option *ngFor="let tipoPlanilla of TipoPlanilla" [value]="tipoPlanilla.idGuia" >
                   {{tipoPlanilla.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})



export class SelectTipoPlanillaComponent implements OnInit {

  @Output() tipoPlanilla : EventEmitter<string> = new EventEmitter();
  @Input() tipoPlanillaElement:string;
  @Input() require : boolean;
  TipoPlanilla:any;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.TipoPlanilla.subscribe(
      response => {
        this.TipoPlanilla = response;   
      });
  }

  changeClient(value) {
    
    this.tipoPlanilla.emit(value);
}
}

//select BancoIF

@Component({
  selector: 'app-select-bancoif',
  template: `<mat-form-field><mat-label>Banco</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="bancoIFElement" [required] = "require">
               <div *ngIf="view">
                  <mat-option value=''>
                    All
                  </mat-option>
                </div>
                  <mat-option *ngFor="let bancoIF of TipoBancoIF" [value]="bancoIF.idGuia" >
                   {{bancoIF.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})



export class SelectBancoIFComponent implements OnInit {

  @Output() bancoIF : EventEmitter<string> = new EventEmitter();
  @Input() bancoIFElement:string;
  @Input() view : boolean;
  @Input() require : boolean;
  TipoBancoIF:any;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.TipoBancoIF.subscribe(
      response => {
        this.TipoBancoIF= response;   
      });
  }

  changeClient(value) {
    
    this.bancoIF.emit(value);
}
}

//select Participante

@Component({
  selector: 'app-select-participante',
  template: `<mat-form-field><mat-label>Participante</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="participanteElement" [required] = "require">
                  <mat-option *ngFor="let participante of Participante" [value]="participante.Codigo" >
                   {{participante.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})



export class SelectParticipanteComponent implements OnInit {

  @Output() participante : EventEmitter<string> = new EventEmitter();
  @Input() participanteElement:string;
  @Input() require : boolean;
  Participante:any;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.Participante.subscribe(
      response => {
        this.Participante = response;   
      });
  }

  changeClient(value) {
    this.participante.emit(value);
}
}

//select RutTitular
@Component({
  selector: 'app-select-RutTitular',
  template: `<mat-form-field><mat-label>Rut Titular</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="rutTitularElement" [required] = "require">
                  <mat-option *ngFor="let rutTitular of RutTitular" [value]="rutTitular.Codigo" >
                   {{rutTitular.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})



export class SelectRutTitularComponent implements OnInit {

  @Output() rutTitular : EventEmitter<string> = new EventEmitter();
  @Input() rutTitularElement:string;
  @Input() require : boolean;
  RutTitular:any;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.RutTitular.subscribe(
      response => {
        this.RutTitular = response;   
      });
  }

  changeClient(value) {
    this.rutTitular.emit(value);
}
}

//select TipoSolicitud

@Component({
  selector: 'app-select-tipoSolicitud',
  template: `<mat-form-field><mat-label>Tipo de solicitud</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="tipoSolicitudElement" [required] = "require">
               <div *ngIf="view">
                  <mat-option value=0>
                    All
                  </mat-option>
                </div>
                  <mat-option *ngFor="let tipoSolicitud of TipoSolicitud" [value]="tipoSolicitud.idGuia" >
                   {{tipoSolicitud.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})

export class SelectTipoSolicitudComponent implements OnInit {

  @Output() tipoSolicitud : EventEmitter<string> = new EventEmitter();
  @Input() tipoSolicitudElement:string;
  @Input() view : boolean;
  @Input() require : boolean;
  TipoSolicitud:any;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.TipoSolicitud.subscribe(
      response => {
        this.TipoSolicitud= response;   
      });
  }

  changeClient(value) {
    
    this.tipoSolicitud.emit(value);
}
}

//select TipoAdjunto

@Component({
  selector: 'app-select-tipoAdjunto',
  template: `<mat-form-field><mat-label>Tipo de documento adjunto</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)"  [(ngModel)]="tipoAdjuntoElement" (filtroAdjunto)="filtroAdjunto" [required] = "require">
               <div *ngIf="view">
                  <mat-option value=0>
                    All
                  </mat-option>
                </div>
                  <mat-option *ngFor="let tipoAdjunto of TipoAdjunto" [value]="tipoAdjunto.idGuia" >
                   {{tipoAdjunto.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})



export class SelectTipoAdjuntoComponent implements OnInit {

  @Output() tipoAdjunto : EventEmitter<string> = new EventEmitter();
  @Input() tipoAdjuntoElement:string;
  @Input() filtroAdjunto:string;
  @Input() view : boolean;
  @Input() require : boolean;
  TipoAdjunto:any=[];

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.TipoAdjunto.subscribe(
      response => {
        this.TipoAdjunto= response; 
        if (this.filtroAdjunto) {
          this.TipoAdjunto =  this.TipoAdjunto.filter(
            state => state.Codigo == this.filtroAdjunto
          );
        }
      });
  }

  changeClient(value) {
    
    this.tipoAdjunto.emit(value);
}
}

//select TipoOperacion

@Component({
  selector: 'app-select-tipoOperacion',
  template: `<mat-form-field [appearance]="modelSelect"><mat-label>Tipo de operación</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="tipoOperacionElement" [disabled]="disable" [required] = "require">
               <div *ngIf="view">
                  <mat-option value=0>
                    All
                  </mat-option>
                </div>
                  <mat-option *ngFor="let tipoOperacion of TipoOperacion" [value]="tipoOperacion.idGuia" >
                   {{tipoOperacion.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})

export class SelectTipoOperacionComponent implements OnInit {
Id_Tipo_DNI=environment.ID_TIPO_DNI;
  @Output() tipoOperacion : EventEmitter<string> = new EventEmitter();
  @Input() tipoOperacionElement:string;
  @Input() view : boolean;
  @Input() require : boolean;
  @Input() modelSelect : string;
  @Input() disable : boolean;
  TipoOperacion:any;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.TipoOperacion.subscribe(
      response => {
        this.TipoOperacion= response;   
      });
  }

  changeClient(value) {
    
    this.tipoOperacion.emit(value);
}
}

//select TipoPagoCPE

@Component({
  selector: 'app-select-tipoPagoCPE',
  template: `<mat-form-field [appearance]="modelSelect"><mat-label>Tipo de pago</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="tipoPagoCPEElement" [disabled]="disable" [required] = "require">
               <div *ngIf="view">
                  <mat-option value=0>
                    All
                  </mat-option>
                </div>
                  <mat-option *ngFor="let tipoPagoCPE of TipoPagoCPE" [value]="tipoPagoCPE.idGuia" >
                   {{tipoPagoCPE.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})

export class SelectTipoPagoCPEComponent implements OnInit {

  @Output() tipoPagoCPE : EventEmitter<string> = new EventEmitter();
  @Input() tipoPagoCPEElement:string;
  @Input() view : boolean;
  @Input() require : boolean;
  @Input() modelSelect : string;
  @Input() disable : boolean;
  TipoPagoCPE:any;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.TipoPagoCPE.subscribe(
      response => {
        this.TipoPagoCPE= response;  
      });
  }

  changeClient(value) {
    
    this.tipoPagoCPE.emit(value);
}
}

//select TipoOperacionNC

@Component({
  selector: 'app-select-tipoOperacionNC',
  template: `<mat-form-field [appearance]="modelSelect"><mat-label>Tipo de operación</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="tipoOperacionNCElement" [disabled]="disable" [required] = "require">
               <div *ngIf="view">
                  <mat-option value=0>
                    All
                  </mat-option>
                </div>
                  <mat-option *ngFor="let tipoOperacionNC of TipoOperacionNC" [value]="tipoOperacionNC.idGuia" >
                   {{tipoOperacionNC.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})

export class SelectTipoOperacionNCComponent implements OnInit {

  @Output() tipoOperacionNC : EventEmitter<string> = new EventEmitter();
  @Input() tipoOperacionNCElement:string;
  @Input() view : boolean; 
  @Input() require : boolean;
  @Input() modelSelect : string;
  @Input() disable : boolean;
  TipoOperacionNC:any;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.TipoOperacionNC.subscribe(
      response => {
        this.TipoOperacionNC= response;  
      });
  }

  changeClient(value) {
    
    this.tipoOperacionNC.emit(value);
}
}
//select TipoServicio
@Component({
  selector: 'app-select-tipoServicio',
  template: `<mat-form-field [appearance]="modelSelect"><mat-label>Tipo de servicio</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="tipoServicioElement" [ngModelOptions]="{standalone: true}" (filtroTipoServicio)="filtroTipoServicio" [disabled]="disable" [required] = "require">
               <div *ngIf="view">
                  <mat-option value=''>
                    Seleccionar
                  </mat-option>
                </div> 
                  <mat-option *ngFor="let tipoServicio of TipoServicio" [value]="tipoServicio.idGuia" >
                   {{tipoServicio.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})

export class SelectTipoServicioComponent implements OnInit {

  @Output() tipoServicio : EventEmitter<string> = new EventEmitter();
  @Input() tipoServicioElement:string;
  @Input() view : boolean;
  @Input() require : boolean;
  @Input() modelSelect : string;
  @Input() disable : boolean;
  @Input() filtroTipoServicio:string;
  @Input() filtroTipoServicioIn:string;
  TipoServicio:any;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.TipoServicio.subscribe(
      response => {
        let list = Array.isArray(response) ? response : [];
        if (this.filtroTipoServicio) {
          list = list.filter(
            state => state.Codigo != this.filtroTipoServicio
          );
        }
        if (this.filtroTipoServicioIn) {
          list = list.filter(
            state => state.Codigo == this.filtroTipoServicioIn
          );
        } else if (environment.SERVIFIN_MODE) {
          list = filterServifinTiposServicio(list);
        }
        this.TipoServicio = list;
      });
  }

  changeClient(value) {
    
    this.tipoServicio.emit(value);
}
}

//select EntidadFinanciera
@Component({
  selector: 'app-select-entidadFinanciera',
  template: `<mat-form-field [appearance]="modelSelect"><mat-label>Banco</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="entidadFinancieraElement" [disabled]="disable" [required] = "require">
               <div *ngIf="view">
                  <mat-option value=0>
                    All
                  </mat-option>
                </div>
                  <mat-option *ngFor="let entidadFinanciera of EntidadFinanciera" [value]="entidadFinanciera.idGuiaBanco" >
                   {{entidadFinanciera.NombreBanco}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})

export class SelectEntidadFinancieraComponent implements OnInit {

  @Output() entidadFinanciera : EventEmitter<any> = new EventEmitter();
  @Output() arrayCuenta : EventEmitter<any> = new EventEmitter();
  @Input() entidadFinancieraElement:string;
  @Input() view : boolean;
  @Input() require : boolean;
  @Input() modelSelect : string;
  @Input() disable : boolean;
  EntidadFinanciera:any[] = [];

  entidadF:any=[];
  arrayEntidadFinanciera:any=[];
  cboEntidadF:any={};
  cboEntidadFinanciera:any=[];
  cboMoneda:any=[];
  cboBanco:any=[];
  cboCuenta:any=[];
  idEmpresa_Factor:any;

  constructor(private guiasService:GuiasService) {
    const user = JSON.parse(sessionStorage.getItem('UserActive') || '{}');
    this.idEmpresa_Factor = Number(user.id_empresa);
   }

  ngOnInit() {
    this.guiasService.EntidadFinanciera.subscribe(
      response => {
        if (!response || !Array.isArray(response) || response.length === 0) {
          this.EntidadFinanciera = [];
          this.cboEntidadFinanciera = [];
          this.arrayCuenta.emit([]);
          return;
        }

        this.cboEntidadFinanciera = [];
        const factorId = Number(this.idEmpresa_Factor);
        this.entidadF = response.filter(
          state => state.Codigo === 'FACT_BANCO_GENERAL' && Number(state.id_empresa) === factorId
        );

        if (this.entidadF.length === 0) {
          this.entidadF = response.filter(state => state.Codigo === 'FACT_BANCO_GENERAL');
        }

        for (const item of this.entidadF) {
          if (!item.Descripcion) {
            continue;
          }
          this.cboEntidadF = {};
          this.arrayEntidadFinanciera = String(item.Descripcion).split('|');
          this.cboEntidadF.NombreBanco = this.arrayEntidadFinanciera[0];
          this.cboEntidadF.Nombre_Firmante = this.arrayEntidadFinanciera[1];
          this.cboEntidadF.TipoEntidad = this.arrayEntidadFinanciera[2];
          this.cboEntidadF.DescripcioEntidad = this.arrayEntidadFinanciera[3];
          this.cboEntidadF.MonedaBanco = this.arrayEntidadFinanciera[4];
          this.cboEntidadF.NumeroCuenta = this.arrayEntidadFinanciera[5];
          this.cboEntidadF.NumeroCuentaInt = this.arrayEntidadFinanciera[6];
          this.cboEntidadF.idGuiaBanco = this.arrayEntidadFinanciera[7];
          this.cboEntidadF.idGuiaMoneda = this.arrayEntidadFinanciera[8];
          this.cboEntidadFinanciera.push(this.cboEntidadF);
        }

        const hash = {};
        this.EntidadFinanciera = this.cboEntidadFinanciera.filter(function(current) {
          const exists = !hash[current.NombreBanco];
          hash[current.NombreBanco] = true;
          return exists;
        });

        this.arrayCuenta.emit(this.cboEntidadFinanciera);
      });
  }

  changeClient(value) {
    this.arrayCuenta.emit(this.cboEntidadFinanciera);
    this.entidadFinanciera.emit(value);
}
}

//Select TipoFacturacion
@Component({
  selector: 'app-select-tipoFacturacion',
  template: `<mat-form-field [appearance]="modelSelect"><mat-label>{{titulo}} </mat-label>
              <mat-select  (selectionChange)="changeClient($event.value)" [(ngModel)]="tipoFacturacionElement" [disabled]="disable" required>
                  <mat-option *ngFor="let tipoFacturacion of tipoFacturacion" [value]="tipoFacturacion.TablaValor" >
                   {{tipoFacturacion.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})

export class SelectTipoFacturacion implements OnInit {

  @Input() tipoFacturacionElement:string;
  @Input() disable:boolean ;
  @Input() modelSelect : string;
  @Input() tituloSN : string;
  @Output() TipoFacturacion : EventEmitter<string> = new EventEmitter();
  tipoFacturacion:any;
  enable:boolean;
  titulo:string = "";
  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    if (this.tituloSN == "1") {
      console.log('this.tituloSN',this.tituloSN);
      this.titulo = "Tipo Facturación"
    }

    this.guiasService.TipoFacturacion.subscribe(
      response => {
         this.tipoFacturacion = response;
      });
  }

  changeClient(value) {  
    this.TipoFacturacion.emit(value);
}
}

//select RepresentanteIF
@Component({
  selector: 'app-multiselect-representanteIF',
  template: ` <form #f='ngForm'>
              <angular2-multiselect [data]="CboRepresentanteIFF" [(ngModel)]="selectedItems" [ngModelOptions]="{standalone: true}" [settings]="dropdownSettings" (onSelect)="onItemSelect($event)" (onDeSelect)="OnItemDeSelect($event)" (onSelectAll)="onSelectAll($event)" (onDeSelectAll)="onDeSelectAll($event)" name='selectedItems'
                  ngModel>
              </angular2-multiselect>
              <p style="color:red" *ngIf="!requiredField">
                  Seleccionar firmante
              </p>
            </form>`
})

export class MultiSelectRepresentanteIFComponent implements OnInit {
  Id_Tipo_DNI=environment.ID_TIPO_DNI;
  @Output() selectedItem : EventEmitter<any> = new EventEmitter();

  dropdownSettings = {};
  requiredField: boolean = true;
  inputDefault : any = [];
  searchField:string ="";
  dropdownList = [];
  selectedItems = [];
 
  RepresentanteIF:any=[];
  ArrayRepresentanteIF:any=[];
  CboRepresentanteIF:any={};
  CboRepresentanteIFF:any=[];

  dataSelect:any=[];
  idEmpresa_Factor:any;

  constructor(private guiasService:GuiasService) {
    const userActive = sessionStorage.getItem('UserActive');
    this.idEmpresa_Factor = userActive ? JSON.parse(userActive).id_empresa : null;

    this.guiasService.RepresentanteIF.subscribe(response => {
      this.loadRepresentantesIF(response);
    });
  }

  private loadRepresentantesIF(response: any): void {
    if (!Array.isArray(response)) {
      return;
    }

    const items = [];
    const filtered = response.filter(
      state => Number(state.id_empresa) === Number(this.idEmpresa_Factor)
    );

    for (const item of filtered) {
      const parts = (item.Descripcion || '').split('|');
      items.push({
        idRepresentanteIF: parts[0],
        Nombre_Firmante: parts[1],
        Num_Doc_Identificacion: parts[2],
        Cargo: parts[3],
        Raz_Social: parts[4],
        RUC: parts[5],
        Tipo_Firmante: parts[6],
        Direccion: parts[7],
        Distrito: parts[8],
        Provincia: parts[9],
        Correo: ' ',
        Telefono: ' ',
        Tipo_Doc_Identificacion: this.Id_Tipo_DNI
      });
    }

    this.CboRepresentanteIFF = items;
    this.inputDefault = items.filter(
      state => String(state.Tipo_Firmante) === '1'
    );
    this.selectedItems = this.inputDefault.slice();
    this.setStatus();
  }

  ngOnInit() {

      this.dropdownSettings = {
        singleSelection: false,
        text: "Seleccionar firmante",
        selectAllText: 'Seleccionar todo',
        unSelectAllText: 'Desmarcar todo',
        noDataLabel: 'No hay datos disponibles',
        enableSearchFilter: false,
        labelKey: 'Nombre_Firmante',
        primaryKey: 'idRepresentanteIF',
        classes: "myclass custom-class",
        badgeShowLimit: 3,
        limitSelection:3
      };

  }

  


  onItemSelect(item: any) {
    this.setStatus();
  }

  setStatus() {
    (this.selectedItems.length > 0) ? this.requiredField = true : this.requiredField = false;
    this.selectedItem.emit(this.selectedItems);
  }

  OnItemDeSelect(item: any) {
    this.setStatus();
  }

  onSelectAll(items: any) {
    this.setStatus();
  }

  onDeSelectAll(items: any) {
    this.selectedItems = [];
    this.setStatus();
  }

  filterRecords(textToSearch: string) {
    const term = (textToSearch || '').toLowerCase();
    const tempArray = [];
    this.inputDefault.forEach((item) => {
      const nombre = (item.Nombre_Firmante || '').toLowerCase();
      if (!term || nombre.indexOf(term) > -1) {
        tempArray.push(item);
      }
    });
    if (tempArray.length > 0) {
      this.selectedItems = tempArray;
      this.setStatus();
    }
  }
}

//select RepresentanteCliente
@Component({
  selector: 'app-multiselect-representanteCLI',
  template: ` <form #f='ngForm'>
              <angular2-multiselect [data]="dataCombo" [(ngModel)]="selectedItems" [ngModelOptions]="{standalone: true}" [settings]="dropdownSettings" (onSelect)="onItemSelect($event)" (onDeSelect)="OnItemDeSelect($event)" (onSelectAll)="onSelectAll($event)" (onDeSelectAll)="onDeSelectAll($event)" name='selectedItems'
                  ngModel>
              </angular2-multiselect>
              <p style="color:red" *ngIf="!requiredField">
                  Seleccione Firmante o representante!
              </p>
            </form>`
})

export class MultiSelectRepresentanteCLIComponent implements OnInit {
  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;

  @Output() selectedItem : EventEmitter<any> = new EventEmitter();
  dataCombo:any=[];

  dropdownSettings = {};
  requiredField: boolean = true;
  inputDefault : any = [];
  searchField:string ="";
  dropdownList = [];
  selectedItems = [];
 
  RepresentanteCLI:any=[];
  ArrayRepresentanteIF:any=[];
  CboRepresentanteIF:any={};
  CboRepresentanteCLII:any=[];

  dataSelect:any=[];

  constructor(private guiasService:GuiasService) {
         
   }

  ngOnInit() {
    this.dropdownSettings = {
      singleSelection: false,
      text: "Seleccione firmante del " + this.Label_Adquirente,
      selectAllText: 'Seleccionar todo',
      unSelectAllText: 'Desmarcar todo',
      noDataLabel: 'No hay datos disponibles',
      enableSearchFilter: false,
      labelKey: 'NombreCorreo',
      primaryKey: 'idContacto',
      classes: "myclass custom-class",
      badgeShowLimit: 3,
      limitSelection: 3
    };

    this.guiasService.RepresentanteCLI.subscribe(
      response => {
        this.dataCombo = response;
        if (this.dataCombo.length > 0) {
          this.inputDefault=[];
          this.dataCombo.forEach((item, index) => {
            if(index < 3) {
              this.inputDefault.push(item);
            }
          })
          this.selectedItem.emit(this.inputDefault);
          this.filterRecords(this.searchField);
        }
      });
  }

  onItemSelect(item: any) {
    this.setStatus();
  }

  setStatus() {
    (this.selectedItems.length > 0) ? this.requiredField = true : this.requiredField = false;
    this.selectedItem.emit(this.selectedItems);
  }

  OnItemDeSelect(item: any) {
    this.setStatus();
  }

  onSelectAll(items: any) {
    this.setStatus();
  }

  onDeSelectAll(items: any) {
    this.selectedItems = [];
    this.setStatus();
  }

  filterRecords(textToSearch: string) {
    const term = (textToSearch || '').toLowerCase();
    const tempArray = [];
    this.inputDefault.forEach((item) => {
      const correo = (item.Correo || '').toLowerCase();
      const nombre = (item.NombreCorreo || item.Nombre_de_Contacto || '').toLowerCase();
      if (!term || correo.indexOf(term) > -1 || nombre.indexOf(term) > -1) {
        tempArray.push(item);
      }
    });
    if (tempArray.length > 0) {
      this.selectedItems = tempArray;
      this.setStatus();
    }
  }


 

}